import { createSelector } from 'reselect';
import { get as _get } from 'lodash';

import { selectIdFromProps } from 'services/selectors';

const selectSortable = state => state.sortable;

export const selectSortablePool = createSelector(selectSortable, selectIdFromProps, (sortable, id) =>
    _get(sortable, id, []),
);
